module.exports = __webpack_public_path__ + "img/logo.9421f66d.png";